import React, { useEffect, useRef } from "react";

import BlockLoop from "components/blockLoop/blockLoop.component";
import * as homeConfig from "./home.config";
import HomeStage from "./home.stage";
import "./home.component.scss";

interface Props {
  onLoaded: () => void;
}

const Home: React.FC<Props> = (props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const homeStage = useRef<HomeStage>();

  const handleStageLoaded = () => props.onLoaded();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!!canvas && !homeStage.current) {
      // init webGL
      homeStage.current = new HomeStage(canvas, handleStageLoaded);
    }
    // return () => {
    //   !!homeStage.current && homeStage.current.destroy();
    //   homeStage.current = undefined;
    // };
  }, []);

  return (
    <div className="home">
      <canvas id="home-canvas" ref={canvasRef} className="home-canvas" />
      <BlockLoop data={homeConfig.home} />
    </div>
  );
};

export default Home;
